export default {
  administrationMetadata: {
    banned: 'Состояние',
    registrationDate: 'Зарегистрирован',
    lastEnter: 'Посл. вход',
    companies: 'Компании',
    copyLinkSuccess: 'Скопировано в буфер обмена',
    copyUid: 'Скопировать UID в буфер обмена',
    copyMail: 'Скопировать Email в буфер обмена',
    copyLinkFailed: 'Ошибка при копировании email',
    text: 'Полнотекстовый',
    byCompany: 'По компании',
    changeEmail: 'Изменение email',
    newEmail: 'Новый email',
    ban: 'Заблокировать',
    unban: 'Разблокировать',
    setImp: 'Выдать роль для входа от имени другого пользователя',
    unsetImp: 'Забрать роль для входа от имени другого пользователя',
    impersonate: 'Войти под этим пользователем',
    imp: 'Имперс.',
  },
};
